import { render } from "./ProjectFilter.vue?vue&type=template&id=c24a99de&scoped=true&ts=true"
import script from "./ProjectFilter.ts?vue&type=script&lang=ts"
export * from "./ProjectFilter.ts?vue&type=script&lang=ts"

import "./ProjectFilter.scss?vue&type=style&index=0&id=c24a99de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24a99de"]])

export default __exports__